import React from 'react';
import AdminBar from './admin-bar';

export default function AdminHeader(props: any) {
    return <AdminBar session={props.session} />;
}
